import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import wtyReportApi from "../../services/warrantyReportAxios";

const initialState = {
    searchedPin: String(''),
    pipList: [],
    loading: false,
    error: null
}


export const getPipInfo = createAsyncThunk(
    'pipList/getPip', async (searchObject) => {
        const pipSearchApiUrl = '/pip/getPIPInfo';
        try {
            const response = await wtyReportApi.get(pipSearchApiUrl, searchObject);
            if (response.status !== 200) {
                new Error("Error occurred while fetching the PIP information.")
            }
            return await response.data;
        } catch (error) {

        }
    });

export const pipSearchSlice = createSlice({
    name: 'pipList',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getPipInfo.pending, state => {
                state.loading = true;
                state.pipList = [];
            })
            .addCase(getPipInfo.rejected, (state) => {
                state.loading = false;
                state.pipList = [];
            })
            .addCase(getPipInfo.fulfilled, (state, action) => {
                state.loading = false;
                state.pipList = action.payload;
            })
    }
});

export const pipList = (state) => state.pipList.pipList;

export const pipsLoading = (state) => state.pipList.loading;
export default pipSearchSlice.reducer;